import { apiService } from "./api";
import {
    FinancialAccount,
    FinancialAccountWithBalance,
    FinancialAccountCreate,
    FinancialAccountUpdate,
    FinancialAccountSimple,
    AccountTransfer,
    AccountTransferCreate,
    AccountAdjustment,
    AccountAdjustmentCreate,
    AccountStatementEntry,
} from "../types/accounts";

class FinancialAccountService {
    async listAccounts(activeOnly: boolean = false, asOf?: string): Promise<FinancialAccountWithBalance[]> {
        return apiService.get<FinancialAccountWithBalance[]>("/accounts", {
            params: { active_only: activeOnly, as_of: asOf },
        });
    }

    async getSimple(activeOnly: boolean = true): Promise<FinancialAccountSimple[]> {
        return apiService.get<FinancialAccountSimple[]>("/accounts/simple", {
            params: { active_only: activeOnly },
        });
    }

    async getAccount(accountId: string, asOf?: string): Promise<FinancialAccountWithBalance> {
        return apiService.get<FinancialAccountWithBalance>(`/accounts/${accountId}`, {
            params: { as_of: asOf },
        });
    }

    async createAccount(data: FinancialAccountCreate): Promise<FinancialAccount> {
        return apiService.post<FinancialAccount>("/accounts", data);
    }

    async updateAccount(accountId: string, data: FinancialAccountUpdate): Promise<FinancialAccount> {
        return apiService.put<FinancialAccount>(`/accounts/${accountId}`, data);
    }

    async deleteAccount(accountId: string): Promise<void> {
        return apiService.delete(`/accounts/${accountId}`);
    }

    async getStatement(accountId: string, dateFrom?: string, dateTo?: string): Promise<AccountStatementEntry[]> {
        return apiService.get<AccountStatementEntry[]>(`/accounts/${accountId}/statement`, {
            params: { date_from: dateFrom, date_to: dateTo },
        });
    }

    async listTransfers(accountId?: string, skip: number = 0, limit: number = 100): Promise<AccountTransfer[]> {
        return apiService.get<AccountTransfer[]>("/accounts/transfers", {
            params: { account_id: accountId, skip, limit },
        });
    }

    async createTransfer(data: AccountTransferCreate): Promise<AccountTransfer> {
        return apiService.post<AccountTransfer>("/accounts/transfers", data);
    }

    async createAdjustment(accountId: string, data: AccountAdjustmentCreate): Promise<AccountAdjustment> {
        return apiService.post<AccountAdjustment>(`/accounts/${accountId}/adjustments`, data);
    }
}

export const financialAccountService = new FinancialAccountService();
